export default import.meta.ROLLDOWN_FILE_URL_N4FJCAHj_LUP1U7r6y$b$w